import { type ReactNode } from 'react';

import { noop } from '@/packages/utils';

import { GalleryLayout } from '../../containers/CardContainer/components/GalleryLayout';
import { PublisherDesktopLayout } from '../../containers/CardContainer/components/PublisherDesktopLayout';
import { CardContentLayout } from '../CardContentLayout';
import { CardLayout } from '../CardLayout';
import { SkeletonRect } from '../SkeletonRect';

import styles from './SkeletonCardList.css';

type TSceletonCardList = {
  of: number;
  isTop: boolean;
};

export function SkeletonCardList({ of, isTop }: TSceletonCardList): ReactNode {
  return (
    <>
      {Array.from({ length: of }).map((_, index) => (
        <CardLayout
          content={
            <CardContentLayout
              actions={<SkeletonRect className={styles['actions']} />}
              description={
                <div className={styles['description']}>
                  <SkeletonRect />
                </div>
              }
              geo={
                <div className={styles['geo']}>
                  <SkeletonRect className={styles['geo-item']} />
                  <SkeletonRect className={styles['geo-item']} />
                  <SkeletonRect className={styles['geo-item']} />
                </div>
              }
              labels={
                <div className={styles['labels']}>
                  <SkeletonRect className={styles['labels-item']} />
                  <SkeletonRect className={styles['labels-item']} />
                </div>
              }
              price={<SkeletonRect className={styles['price']} />}
              promotion={null}
              publisher={
                <div className={styles['publisher-container']}>
                  <SkeletonRect className={styles['publisher']} />
                  <SkeletonRect className={styles['publication-date']} />
                </div>
              }
              subtitle={<SkeletonRect className={styles['subtitle']} />}
              title={<SkeletonRect className={styles['title']} />}
            />
          }
          gallery={
            <GalleryLayout
              slider={<SkeletonRect className={styles['gallery']} />}
              thumbnails={
                <div className={styles['thumbnails']}>
                  <SkeletonRect className={styles['thumbnail']} />
                  <SkeletonRect className={styles['thumbnail']} />
                  <SkeletonRect className={styles['thumbnail']} />
                </div>
              }
            />
          }
          isTop={isTop}
          key={`skeleton-item-${index}`}
          publisher={
            <PublisherDesktopLayout
              controls={null}
              promotionDescription={null}
              publicationDate={null}
              publisher={
                <div className={styles['publisher-desktop']}>
                  <SkeletonRect className={styles['publisher-avatar']} />

                  <div className={styles['publisher-content']}>
                    <SkeletonRect height={20} />
                    <SkeletonRect height={20} />
                    <SkeletonRect height={20} />
                  </div>

                  <div className={styles['publisher-actions']}>
                    <SkeletonRect height={28} />
                    <SkeletonRect height={28} />
                  </div>
                </div>
              }
            />
          }
          onClick={noop}
        />
      ))}
    </>
  );
}
